import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input';
import type { Country } from 'react-phone-number-input';

import type Locale from 'react-phone-number-input/locale/en.json';
import type { Dispatch, SetStateAction } from 'react';
import { useField } from 'remix-validated-form';
import { useTranslation } from 'react-i18next';

type TProps = {
  value: string | undefined;
  onChange: Dispatch<SetStateAction<Country | undefined>>;
  labels: Locale;
};

const PrefixSelect = ({ value, onChange, labels }: TProps) => {
  const { t } = useTranslation();
  const { error } = useField('mobilePrefix');
  return (
    <div className="form-floating">
      <select
        name="country"
        value={value || 'FR'}
        onChange={(event) => onChange(event.target.value as Country)}
        className={` form-select  ${error ? 'is-invalid' : ''}`}
        id="select-country-id"
      >
        {getCountries().map((country) => (
          <option
            key={country}
            value={country}
          >
            {labels[country]} +({getCountryCallingCode(country)})
          </option>
        ))}
      </select>
      <label>{t('forms.phone.prefix.label')}</label>
    </div>
  );
};
export default PrefixSelect;
